<script>
import 'chartjs-adapter-moment'
import { Line } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  name: 'CLineChart',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  watch: {
    chartData () {
      this.renderLineChart()
    }
  },
  mounted () {
    this.addPlugin(ChartDataLabels)
  },
  methods: {
    renderLineChart () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
